module.exports = __webpack_public_path__ + "img/5.9e5c8987.png";